module.exports = __webpack_public_path__ + "static/img/ic_filter_off@2x.40cfb6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_filter_off@2x.png
// module id = fbG8
// module chunks = 1